module.exports = __webpack_public_path__ + "img/top-logo-r.f65b8be9.jpg";